<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-75 p-0">

            <form @submit.prevent="addApp()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Adicionar Aplicação</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3 overflow-auto" style="max-height: 70vh;">

                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField :required="true" label="Nome da aplicação *" type="text"
                                placeHolder="Digite aqui o nome da aplicação *" v-model="newAplicacao.nome" />
                        </div>

                        <div class="flex-1">
                            <InputField :required="true" label="Nome do responsável pela aplicação *" type="text"
                                placeHolder="Digite aqui o nome do responsável pela aplicação *"
                                v-model="newAplicacao.responsavel" />
                        </div>

                    </div>

                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">

                            <div class="d-flex gap-2">
                                <div>
                                    <input v-model="newAplicacao.tipo_registro" type="radio" value="cpf" />
                                    CPF
                                </div>

                                <div>
                                    <input v-model="newAplicacao.tipo_registro" type="radio" value="cnpj" />
                                    CNPJ
                                </div>
                            </div>

                            <InputField :required="true" type="text"
                                :placeHolder="(newAplicacao.tipo_registro == 'cpf') ? 'Digite aqui o CPF *' : 'Digite aqui o CNPJ *'"
                                v-model="newAplicacao.cnpj_cpf" :maskType="newAplicacao.tipo_registro" />

                        </div>

                    </div>

                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField :required="true" label="Email *" type="email" placeHolder="example@gmail.com"
                                v-model="newAplicacao.email" />
                        </div>

                        <div class="flex-1">
                            <InputField :required="true" label="Telefone *" type="text" placeHolder="(99) 9999-9999"
                                v-model="newAplicacao.telefone" maskType="phone" />
                        </div>

                    </div>

                    <div class="mb-0">

                        <div>
                            <InputField :required="true" label="URL de acesso *" type="text"
                                placeHolder="Digite aqui a url de acesso *" v-model="newAplicacao.url" />
                        </div>
                        <p class="mb-0 mt-1">
                            https://{{ newAplicacao.url }}.axionapp.com.br
                        </p>

                    </div>

                    <hr>

                    <div class="d-flex gap-2">

                        <div v-if="authStore.usuario.root" class="flex-1">
                            <SelectField classLabel="form-label" label="Parceria *" labelOption="nome"
                                :options="getParcerias()" placeHolder="Escolha uma parceria *" valueProp="id"
                                :canClear="false" v-model="newAplicacao.parceriaId" :required="true"
                                @update:modelValue="updateParceriaSelecionado" />
                        </div>

                        <div class="flex-1">

                            <SelectField classLabel="form-label" label="Plano" labelOption="nome" :options="getPlanos()"
                                placeHolder="Escolha um Plano" valueProp="id" :canClear="true"
                                v-model="newAplicacao.planoId" @update:modelValue="updatePlanoSelecionado" />

                        </div>

                        <div class="flex-1">
                            <InputField :required="true" label="Número de usuário *" type="number"
                                placeHolder="Digite aqui o número de usuários *" v-model="newAplicacao.numero_usuarios"
                                min="1" step="1" />
                        </div>

                    </div>

                    <table class="table table-bordered mb-0 mt-2">

                        <thead>
                            <tr>
                                <th></th>
                                <th>Descrição</th>
                                <th>Valor</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr v-if="planoSelecionado?.id">
                                <td></td>
                                <td>Plano: {{ planoSelecionado.nome }}</td>
                                <td><span class="text-success">{{ '+' + $moneyConvert.convert(planoSelecionado.valor)
                                        }}</span></td>
                            </tr>

                            <template v-if="planoSelecionado?.id">
                                <tr v-for="modulo in planoSelecionado.modulos" :key="modulo">
                                    <td></td>
                                    <td>
                                        {{ modulo.nome }}
                                        <small class="text-info">(Adicional de {{ $moneyConvert.convert(modulo.valor) }}
                                            por usuário extra)</small>
                                    </td>
                                    <td>
                                        <template v-if="newAplicacao.numero_usuarios <= 1">
                                            R$ 0,00
                                        </template>

                                        <template v-else>
                                            <span class="text-success">{{ '+' + $moneyConvert.convert(modulo.valor *
                                                (newAplicacao.numero_usuarios - 1) ) }}</span>
                                        </template>

                                        <!-- <small class="text-success"> (Incluido no plano)</small> -->
                                    </td>
                                </tr>
                            </template>


                            <tr>
                                <td class="text-center bg-white" colspan="3">Módulos Adicionais</td>
                            </tr>

                            <tr v-for="modulo in getModulosTable()" :key="modulo">
                                <td class="text-center">
                                    <input type="checkbox" :checked="newAplicacao.modulos.includes(modulo.id)"
                                        @click="updateModuloExtra(modulo)" />
                                </td>
                                <td>
                                    {{ modulo.nome }}
                                    <small class="text-info">(Adicional de {{ $moneyConvert.convert(modulo.valor) }} por
                                        usuário extra)</small>
                                </td>
                                <td>
                                    <template v-if="newAplicacao.modulos.includes(modulo.id)">
                                        <span class="text-success">{{ $moneyConvert.convert(modulo.valor *
                                            newAplicacao.numero_usuarios)}}</span>
                                    </template>
                                    <template v-else>
                                        R$ 0,00
                                    </template>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td>Sub Total</td>
                                <td><span class="text-success">{{ $moneyConvert.convert(getValorSubTotal()) }}</span>
                                </td>
                            </tr>

                            <tr v-if="newAplicacao.parceriaId">
                                <td></td>
                                <td>{{ parceriaSelecionada.percentual_desconto }}% de desconto da Parceria</td>
                                <td> <span class="text-danger">-{{ $moneyConvert.convert(getValorDescontoParceria())
                                        }}</span> </td>
                            </tr>

                        </tbody>

                        <tfoot>
                            <tr>
                                <td></td>
                                <td>Valor Total</td>
                                <td><span class="text-success">{{ $moneyConvert.convert(getValorTotal()) }}</span></td>
                            </tr>
                        </tfoot>

                    </table>


                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Adicionar" type="success" :submit="true" :isLoading="isLoading"
                        :loadingText="'Criando aplicação'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
import { useAplicacoesStore } from '@/stores/aplicacoes.js'
import { useParceriasStore } from '@/stores/parcerias.js';
import { toast } from 'vue3-toastify'
import { useAuthStore } from '@/stores/auth.js';
import { usePlanosStore } from '@/stores/planos';
import { useModulosStore } from '@/stores/modulos';

const defaultAplicaco = { nome: '', responsavel: '', tipo_registro: 'cpf', cnpj_cpf: '', url: '', planoId: '', modulos: [], numero_usuarios: 1 }

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
    },
    emits: ['close'],
    data() {
        return {
            aplicacoesStore: useAplicacoesStore(),
            newAplicacao: { ...defaultAplicaco },
            parceriasStore: useParceriasStore(),
            authStore: useAuthStore(),
            modulosStore: useModulosStore(),
            isLoading: false,
            planosStore: usePlanosStore(),
            planoSelecionado: {},
            parceriaSelecionada: {}
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        async addApp() {

            const newAplicacaoCopy = { ...this.newAplicacao }
            newAplicacaoCopy.url = `https://${newAplicacaoCopy.url}.axionapp.com.br`

            this.isLoading = true
            const result = await this.aplicacoesStore.add(newAplicacaoCopy)

            this.isLoading = false

            if (result.status) {
                toast.success("Aplicação criada com sucesso")
                this.closeModal()
                this.newAplicacao = { ...defaultAplicaco }

                if (this.authStore.parceriaId) {
                    this.newAplicacao.parceriaId = this.authStore.parceriaId
                    this.updateParceriaSelecionado()
                }

                this.aplicacoesStore.get()
            } else {
                toast.error(result.message)
            }

        },
        getParcerias() {
            const parcerias = this.parceriasStore.parcerias.filter(p => p.id != '')
            return parcerias
        },
        getPlanos() {
            const planos = []
            for (const plano of this.planosStore.planos) {
                planos.push({
                    id: plano.id,
                    nome: `${plano.nome} | ${this.$moneyConvert.convert(plano.valor)}`
                })
            }
            return planos
        },
        getModulosTable() {
            if (!this.planoSelecionado.id) return this.modulosStore.modulos
            return this.modulosStore.modulos.filter(m => !this.planoSelecionado.modulos.find(m2 => m2.id == m.id))
        },
        updateModuloExtra(modulo) {
            if (this.newAplicacao.modulos.includes(modulo.id)) {
                this.newAplicacao.modulos = this.newAplicacao.modulos.filter(m => m != modulo.id)
            } else {
                this.newAplicacao.modulos.push(modulo.id)
            }
        },
        async updatePlanoSelecionado() {
            
            
            if(this.newAplicacao.planoId == this.planoSelecionado.id) return

            if (!this.newAplicacao.planoId) {
                this.planoSelecionado = {}
                this.newAplicacao.modulos = []
                return
            }

            const planoSelecionado = await this.planosStore.getOne(this.newAplicacao.planoId)
            this.planoSelecionado = planoSelecionado.plano
            this.newAplicacao.modulos = this.newAplicacao.modulos.filter(m => !this.planoSelecionado.modulos.find(m2 => m == m2.id))
         
            
            return true
            
        },
        getValorSubTotal() {
            let valor = 0
            if (this.planoSelecionado.id) {

                valor += this.planoSelecionado.valor

                if (this.newAplicacao.numero_usuarios > 1) {
                    for (const modulo of this.planoSelecionado.modulos) {
                        valor += modulo.valor * (this.newAplicacao.numero_usuarios - 1)
                    }
                }

            }

            for (const moduloId of this.newAplicacao.modulos) {
                const modulo = this.modulosStore.modulos.find(m => m.id == moduloId)
                valor += (modulo.valor * this.newAplicacao.numero_usuarios)
            }

            return valor
        },
        getValorDescontoParceria() {
            if (!this.parceriaSelecionada.id) return 0

            let valor = (this.parceriaSelecionada.percentual_desconto * this.getValorSubTotal()) / 100
            return valor

        },
        getValorTotal() {
            let valor = this.getValorSubTotal()
            return valor - this.getValorDescontoParceria()
        },
        async updateParceriaSelecionado() {

            if (!this.newAplicacao.parceriaId) {
                this.parceriaSelecionada = {}
                return
            }

            this.parceriaSelecionada = this.parceriasStore.parcerias.find(p => p.id == this.newAplicacao.parceriaId)

        },
    },
    async mounted() {

        await this.parceriasStore.get()

        if (this.authStore.usuario.parceriaId) {
            this.newAplicacao.parceriaId = this.authStore.usuario.parceriaId
            this.updateParceriaSelecionado()
        }

        await this.planosStore.get()
        await this.modulosStore.get()

        const params = new URLSearchParams(window.location.search);
        if (params.get('modalContratar') == 'true') {
            const cache = localStorage.getItem('cacheContratacao')
            if (cache) {

                const objCache = JSON.parse(cache)
                this.newAplicacao.planoId = objCache.planoId
                await this.updatePlanoSelecionado(objCache.planoId)

                this.newAplicacao.modulos = objCache.modulosExtras
                this.newAplicacao.numero_usuarios = objCache.numero_usuarios
            }
        }

    }
}
</script>